import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const HomeIcon = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" />
    <path d="M9 21V12h6v9" />
  </svg>
);

const ChatIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
  </svg>
);

const PersonIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const SlidersIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" />
    <line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" />
    <line x1="17" y1="16" x2="23" y2="16" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
  </svg>
);

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [settingsBadge, setSettingsBadge] = useState(false);

  useEffect(() => {
    setSettingsBadge(localStorage.getItem('profile_needs_photo') === '1');
  }, [pathname]);

  const isMatches = pathname === '/matches' || pathname.startsWith('/match/');
  const isChats = pathname === '/chats' || pathname.startsWith('/chat/');
  const isAbout = pathname === '/about';
  const isDesires = pathname === '/desires';
  const isSettings = pathname === '/settings';

  return (
    <nav className="bottom-nav">
      <button
        className={`nav-icon${isMatches ? ' active' : ''}`}
        onClick={() => navigate('/matches')}
        aria-label="Matches"
      >
        <HomeIcon active={isMatches} />
      </button>
      <button
        className={`nav-icon${isChats ? ' active' : ''}`}
        onClick={() => navigate('/chats')}
        aria-label="Chats"
      >
        <ChatIcon />
      </button>
      <button
        className={`nav-icon${isDesires ? ' active' : ''}`}
        onClick={() => navigate('/desires')}
        aria-label="Desires"
      >
        <SlidersIcon />
      </button>
      <button
        className={`nav-icon${isAbout ? ' active' : ''}`}
        onClick={() => navigate('/about')}
        aria-label="About me"
      >
        <PersonIcon />
      </button>
      <button
        className={`nav-icon${isSettings ? ' active' : ''}`}
        onClick={() => navigate('/settings')}
        aria-label="Settings"
      >
        <div className="nav-icon-wrap">
          <SettingsIcon />
          {settingsBadge && <div className="nav-badge" />}
        </div>
      </button>
    </nav>
  );
}
